export default class VideoPlayerHTML5 {
  constructor(src, container) {
    this.rawSrc = src;
    this.container = container;

    this.loadVideo();
  }

  loadVideo() {
    this.renderPlayer();
  }

  renderPlayer() {
    this.video = document.createElement("video");

    this.video.setAttribute("src", this.rawSrc);
    this.video.setAttribute("controls", true);

    // Append to DOM
    this.container.insertAdjacentElement("afterbegin", this.video);
  }

  play() {
    this.video.play();
  }
}
